export const MILESTONES = [
  { n: 1, title: "Orientation", type: "lessons", moduleId: "m-orientation", blurb: "Breathe. Chill. Drink Lemonade. Learn the spirit." },
  { n: 2, title: "Service Guidelines", type: "lessons", moduleId: "m-service", blurb: "The ten-part standard for every guest." },
  { n: 3, title: "Drinks 411", type: "lessons", moduleId: "m-recipes", blurb: "Smash, pump, shake, poke, serve." },
  { n: 4, title: "Product Certified", type: "checkoff", certKey: "product", blurb: "Sign off on the build criteria." },
  { n: 5, title: "Stand Setup", type: "lessons", moduleId: "m-equipment", blurb: "Syrup rack, ice, cups, open and close." },
  { n: 6, title: "Permits & Legal", type: "lessons", moduleId: "m-legal", blurb: "Health dept, insurance, confidentiality." },
  { n: 7, title: "Event Prep & Numbers", type: "lessons", moduleId: "m-eventprep", blurb: "Forecast, order, staff, score." },
  { n: 8, title: "Smash Standard", type: "checkoff", certKey: "standard", blurb: "The service bar during a real rush." },
  { n: 9, title: "First Event", type: "checklist", blurb: "Work the First Event checklist end to end." },
];

export function milestoneProgress(m, content, state) {
  if (!content || !state) return { done: 0, total: 1 };
  if (m.type === "lessons") {
    const mod = (content.modules || []).find((x) => x.id === m.moduleId);
    const steps = mod ? mod.steps : [];
    return {
      done: steps.filter((s) => (state.completedSteps || []).includes(s.id)).length,
      total: steps.length || 1,
    };
  }
  if (m.type === "checkoff") {
    const criteria = content.certifications?.[m.certKey]?.criteria || [];
    const checked = state.certifications?.[m.certKey] || [];
    return { done: criteria.filter((c) => checked.includes(c.id)).length, total: criteria.length || 1 };
  }
  const items = content.checklist || [];
  return {
    done: items.filter((i) => (state.checklist || []).includes(i.id)).length,
    total: items.length || 1,
  };
}

export function isDone(m, content, state) {
  const { done, total } = milestoneProgress(m, content, state);
  return total > 0 && done >= total;
}

export function overallPercent(content, state) {
  if (!content || !state) return 0;
  const totals = MILESTONES.map((m) => milestoneProgress(m, content, state));
  const done = totals.reduce((a, t) => a + t.done, 0);
  const total = totals.reduce((a, t) => a + t.total, 0);
  return total ? Math.round((done / total) * 100) : 0;
}

export function nextMove(content, state) {
  if (!content || !state) return null;
  const m = MILESTONES.find((x) => !isDone(x, content, state));
  if (!m) return { milestone: null, label: "Every milestone is done. Go run your first event.", action: null };
  if (m.type === "lessons") {
    const mod = (content.modules || []).find((x) => x.id === m.moduleId);
    const step = (mod?.steps || []).find((s) => !(state.completedSteps || []).includes(s.id));
    return { milestone: m, label: step ? step.title : mod?.title, sub: mod?.title, tab: "training" };
  }
  if (m.type === "checkoff") {
    const criteria = content.certifications?.[m.certKey]?.criteria || [];
    const checked = state.certifications?.[m.certKey] || [];
    const c = criteria.find((x) => !checked.includes(x.id));
    return { milestone: m, label: c ? c.text : m.title, sub: "Certification checkoff", tab: "training" };
  }
  const item = (content.checklist || []).find((i) => !(state.checklist || []).includes(i.id));
  return { milestone: m, label: item ? item.item : m.title, sub: item?.stage, tab: "prep" };
}
